module.exports = __webpack_public_path__ + "static/ionic-98a519309df693497af866fb98f5090c.png";